function toggleToFav(element, TableID, SectionID, ProductID)
{
    if (ClientID == null || ClientID == ""){
        //remove product box
        document.getElementById('abs-s').remove();
        //timeout bc the add event listener when clicking outside the sidenav hides the sidenav as it is opened
        setTimeout(function() {
            showSideNavMenu('login-section');
            openSideNav();
        }, 100)
        return;
    }

    var data = {
        "ProductID": ProductID, "TableID": TableID, "SectionID": SectionID
    }

    $.when($.ajax({
        type: "POST",
        url: scriptPath + "/Home?handler=ToggleFavouriteProduct",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(data),
        headers:
        {
            RequestVerificationToken:
                $('input:hidden[name="__RequestVerificationToken"]').val()
        },
        success: function(result) {
        if (result == "Removed"){
            showToast("Producto removido de favoritos", "info", 3000);
            element.classList.remove('fav-button-selected');

            var productCard = document.getElementById(ProductID);
            if (productCard){
                productCard.remove();
            }
        }
        else{
            showToast("Producto agregado a favoritos", "success", 3000);
            element.classList.add('fav-button-selected');
        }
    },
        error: function(result) {
        showToast("Error al agregar el producto a favoritos", "warning", 3000);
        console.log(result);
    }
    })).done(function() {

    })
}